import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { OverviewZoneManager } from '../../../common/view/overviewZoneManager.js';
import { ViewEventHandler } from '../../../common/viewModel/viewEventHandler.js';
export var OverviewRuler = /*#__PURE__*/function (_ViewEventHandler) {
  _inherits(OverviewRuler, _ViewEventHandler);

  var _super = _createSuper(OverviewRuler);

  function OverviewRuler(context, cssClassName) {
    var _this;

    _classCallCheck(this, OverviewRuler);

    _this = _super.call(this);
    _this._context = context;
    var options = _this._context.configuration.options;
    _this._domNode = createFastDomNode(document.createElement('canvas'));

    _this._domNode.setClassName(cssClassName);

    _this._domNode.setPosition('absolute');

    _this._domNode.setLayerHinting(true);

    _this._domNode.setContain('strict');

    _this._zoneManager = new OverviewZoneManager(function (lineNumber) {
      return _this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber);
    });

    _this._zoneManager.setDOMWidth(0);

    _this._zoneManager.setDOMHeight(0);

    _this._zoneManager.setOuterHeight(_this._context.viewLayout.getScrollHeight());

    _this._zoneManager.setLineHeight(options.get(51
    /* lineHeight */
    ));

    _this._zoneManager.setPixelRatio(options.get(115
    /* pixelRatio */
    ));

    _this._context.addEventHandler(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(OverviewRuler, [{
    key: "dispose",
    value: function dispose() {
      this._context.removeEventHandler(this);

      _get(_getPrototypeOf(OverviewRuler.prototype), "dispose", this).call(this);
    } // ---- begin view event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;

      if (e.hasChanged(51
      /* lineHeight */
      )) {
        this._zoneManager.setLineHeight(options.get(51
        /* lineHeight */
        ));

        this._render();
      }

      if (e.hasChanged(115
      /* pixelRatio */
      )) {
        this._zoneManager.setPixelRatio(options.get(115
        /* pixelRatio */
        ));

        this._domNode.setWidth(this._zoneManager.getDOMWidth());

        this._domNode.setHeight(this._zoneManager.getDOMHeight());

        this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
        this._domNode.domNode.height = this._zoneManager.getCanvasHeight();

        this._render();
      }

      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      this._render();

      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      if (e.scrollHeightChanged) {
        this._zoneManager.setOuterHeight(e.scrollHeight);

        this._render();
      }

      return true;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      this._render();

      return true;
    } // ---- end view event handlers

  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode.domNode;
    }
  }, {
    key: "setLayout",
    value: function setLayout(position) {
      this._domNode.setTop(position.top);

      this._domNode.setRight(position.right);

      var hasChanged = false;
      hasChanged = this._zoneManager.setDOMWidth(position.width) || hasChanged;
      hasChanged = this._zoneManager.setDOMHeight(position.height) || hasChanged;

      if (hasChanged) {
        this._domNode.setWidth(this._zoneManager.getDOMWidth());

        this._domNode.setHeight(this._zoneManager.getDOMHeight());

        this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
        this._domNode.domNode.height = this._zoneManager.getCanvasHeight();

        this._render();
      }
    }
  }, {
    key: "setZones",
    value: function setZones(zones) {
      this._zoneManager.setZones(zones);

      this._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      if (this._zoneManager.getOuterHeight() === 0) {
        return false;
      }

      var width = this._zoneManager.getCanvasWidth();

      var height = this._zoneManager.getCanvasHeight();

      var colorZones = this._zoneManager.resolveColorZones();

      var id2Color = this._zoneManager.getId2Color();

      var ctx = this._domNode.domNode.getContext('2d');

      ctx.clearRect(0, 0, width, height);

      if (colorZones.length > 0) {
        this._renderOneLane(ctx, colorZones, id2Color, width);
      }

      return true;
    }
  }, {
    key: "_renderOneLane",
    value: function _renderOneLane(ctx, colorZones, id2Color, width) {
      var currentColorId = 0;
      var currentFrom = 0;
      var currentTo = 0;

      var _iterator = _createForOfIteratorHelper(colorZones),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var zone = _step.value;
          var zoneColorId = zone.colorId;
          var zoneFrom = zone.from;
          var zoneTo = zone.to;

          if (zoneColorId !== currentColorId) {
            ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
            currentColorId = zoneColorId;
            ctx.fillStyle = id2Color[currentColorId];
            currentFrom = zoneFrom;
            currentTo = zoneTo;
          } else {
            if (currentTo >= zoneFrom) {
              currentTo = Math.max(currentTo, zoneTo);
            } else {
              ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
              currentFrom = zoneFrom;
              currentTo = zoneTo;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
    }
  }]);

  return OverviewRuler;
}(ViewEventHandler);